import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'worktimes',
  standalone: false
})
export class WorktimesPipe implements PipeTransform {

  transform(wp: unknown): unknown {
    switch(wp){
      case 'full_time':
        return 'Kokoaikatyö';
      case 'part_time':
        return 'Osa-aikatyö';
      case '3_shift_work':
        return '3-vuorotyö';
      case '2_shift_work':
        return '2-vuorotyö';
      case 'hourly':
        return 'Tuntityö';
      case 'negotiable':
        return 'Työaika sovittavissa';
      default:
        return 'Ei määritelty';
    }
  }

}
